import { IconButton } from "@mui/material";
import React from "react";
import { LocalPrintshop } from "@mui/icons-material";

export default function PrintView({ handleView }) {
  return (
    <IconButton
      sx={{ width: "32px", height: "32px", background: "var(--grey)", color: "#000" }}
      onClick={handleView}
    >
      <LocalPrintshop sx={{ color: "var(--main-grey)", fontSize: "16px", color: "currentColor" }} />
    </IconButton>
  );
}
